// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"68fe8d77","703":"e7fd976c"}[chunkId] + ".chunk.js";
};